export default {"src":"/_next/static/media/IOMA_LOGO.31112b7e.svg","height":120,"width":400,"blurWidth":0,"blurHeight":0};